import api from './api';

/** Shared Asset form dropdowns: masters + status/currency options */
const assetDropdownService = {
  /**
   * Ensures masters have starter data if empty, then returns:
   * { assetTypes, vendors, locations, providers, dropdowns }
   */
  getOptions: async () => {
    const response = await api.get('/asset-dropdowns');
    return response.data;
  }
};

export default assetDropdownService;

/** Fallback static options if API fails (mirrors Dropdown Master categories) */
export const ASSET_DROPDOWN_FALLBACKS = {
  acquisitionStatus: ['Draft', 'Ordered', 'Received', 'Cancelled'],
  assignmentStatus: ['Assigned', 'Returned', 'Transferred'],
  maintenanceStatus: ['Scheduled', 'In Progress', 'Completed', 'Cancelled'],
  maintenanceType: ['Preventive', 'Corrective', 'Inspection'],
  disposalStatus: ['Draft', 'Approved', 'Completed', 'Cancelled'],
  disposalReason: ['Sold', 'Scrapped', 'Donated', 'Lost', 'Other'],
  currency: ['INR', 'USD', 'EUR', 'GBP'],
  masterStatus: ['Active', 'Inactive'],
  assetTypeStatus: ['Active', 'Inactive', 'Suspended'],
  locationType: ['Office', 'Warehouse', 'Remote', 'Other'],
  assetCategory: ['IT Equipment', 'Furniture', 'Vehicles', 'Machinery', 'Office Equipment', 'Software', 'Buildings', 'Other'],
  depreciationMethod: ['Straight Line', 'Declining Balance', 'Units of Production', 'Sum of Years Digits', 'None'],
  maintenanceFrequency: ['Daily', 'Weekly', 'Monthly', 'Quarterly', 'Semi-Annually', 'Annually', 'As Needed'],
  department: ['Sales', 'Marketing', 'Engineering', 'Finance', 'HR', 'Operations', 'IT', 'Admin', 'Other']
};

export function optionsFromDropdown(dropdowns, key, fallbackList) {
  const rows = dropdowns?.[key];
  if (Array.isArray(rows) && rows.length > 0) {
    return rows.map((r) => (typeof r === 'string' ? { label: r, value: r } : { label: r.label || r.value, value: r.value || r.label }));
  }
  return (fallbackList || []).map((v) => ({ label: v, value: v }));
}
